// https://www.mapillary.com/dashboard/developers
// "Tarmac OSM Viewer", they call it "Client Token"
export const apiKeyMapillary = 'MLY|5337311709720950|61508fdcc416406fd8dfb79748463852'
